import { Currency } from '@kodiak-finance/sdk-core'
import CurrencyLogo from 'components/CurrencyLogo'
import Row from 'components/Row'
import { useMemo } from 'react'

import { ExtentsText, RangeLineItem, RangeText } from './styled'

interface PriceRangeDisplayProps {
  provider?: string
  currencyBase?: Currency | null
  currencyQuote?: Currency | null
  priceLower?: any
  priceUpper?: any
  formattedPriceLower?: string | null
  formattedPriceUpper?: string | null
}

const RangeRow = ({
  label,
  value,
  currencyBase,
  currencyQuote,
  style = {},
}: {
  label: string
  value: React.ReactNode
  currencyBase?: Currency | null
  currencyQuote?: Currency | null
  style?: React.CSSProperties
}) => (
  <RangeText>
    <ExtentsText style={{ paddingRight: '3px' }}>{label}</ExtentsText>
    <Row gap="4px" style={{ ...style }}>
      <CurrencyLogo size="14px" currency={currencyBase} />
      <span>1 =</span>
      <CurrencyLogo size="14px" currency={currencyQuote} />
      <span>{value}</span>
    </Row>
  </RangeText>
)

export const PriceRangeDisplay = ({
  provider,
  currencyBase,
  currencyQuote,
  priceLower,
  priceUpper,
  formattedPriceLower,
  formattedPriceUpper,
}: PriceRangeDisplayProps) => {
  return useMemo(() => {
    if (provider === 'charm') {
      return (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            fontSize: '12px',
            fontWeight: '400',
          }}
        >
          Concentrated
        </div>
      )
    }

    if ((!priceLower || !priceUpper) && provider === 'v2') {
      return (
        <RangeLineItem>
          <RangeRow label="Min:" value={0} currencyBase={currencyBase} currencyQuote={currencyQuote} />
          <RangeRow label="Max:" value="∞" currencyBase={currencyBase} currencyQuote={currencyQuote} />
        </RangeLineItem>
      )
    }

    return (
      <RangeLineItem>
        <RangeRow
          label="Min:"
          value={formattedPriceLower}
          currencyBase={currencyBase}
          currencyQuote={currencyQuote}
          style={{ marginLeft: '2.8px' }}
        />
        <RangeRow label="Max:" value={formattedPriceUpper} currencyBase={currencyBase} currencyQuote={currencyQuote} />
      </RangeLineItem>
    )
  }, [provider, currencyBase, currencyQuote, priceLower, priceUpper, formattedPriceLower, formattedPriceUpper])
}

export default PriceRangeDisplay
